import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StaticData } from '../../../helpers/static-data';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss']
})
export class BreadCrumbComponent implements OnInit {

  public href: string = "";
  UserData: any = StaticData.ExternalPqrContact != undefined ? JSON.parse(StaticData.ExternalPqrContact) : StaticData.ExternalPqrContact;

  constructor(private router: Router) { }

  ngOnInit() {
    switch (this.router.url){
      case '/HomeExternalPQR':
        this.href = "Home";
        break;
      case '/InitPQRs':
        this.href = "no";
        break;
      case '/ExternalPQRContact':
        this.href = "Registrarse";
        break;
      case '/ExternalPQRs':
        /*if (this.UserData != null && this.UserData != undefined) 
        {*/
          this.href = "Formular una solicitud";
        /*}
        else
        {
          this.href = "Formular una solicitud anónima";
        }*/
        break;
      case '/ConsultaExternalPQR':
        this.href = "Consultar Radicados";
        break;
      case '/RecuperarContrasena':
        this.href = "Recuperar contraseña";
        break;
      case '/ValidarDocumentoExternalPqrs':
        this.href = "Validar documento";
        break;
      case '/GuiaUsoExternalPqrs':
          this.href = "Guía de uso";
        break;
      /*default:
        this.href = "noo";*/
    } 
  }

  public onClick(event)
  {
    debugger;
    var CurrentUrl = window.location.href;
    window.scrollTo(0, 0);
    //if(CurrentUrl.includes('InitPQRs'))
    if(CurrentUrl.includes('ExternalPQRs'))
    {
      StaticData.ExternalPqrAnonimo = false;
    }
  }

}
